import { StatusBadge } from 'common/components/StatusBadge/StatusBadge';
import {
  BADGE_STATUSES,
  BadgeStatus,
} from 'src/common/components/StatusBadge/StatusBadgeConstants';
import { useTranslation } from 'react-i18next';
import {
  SUBSCRIPTION_STATUS,
  SubscriptionStatus,
  getLabelBaseOnSubscriptionStatus,
} from 'src/common/components/SubscriptionStatus/constants/subscriptionStatus';

const getBadgeStatusBaseOnSubscriptionStatus = (
  subscriptionStatus: SubscriptionStatus | null,
): BadgeStatus => {
  switch (subscriptionStatus) {
    case SUBSCRIPTION_STATUS.ACTIVE: {
      return BADGE_STATUSES.SUCCESS;
    }
    case SUBSCRIPTION_STATUS.DEACTIVATED: {
      return BADGE_STATUSES.INACTIVE;
    }
    case SUBSCRIPTION_STATUS.TEST: {
      return BADGE_STATUSES.PENDING;
    }
    case SUBSCRIPTION_STATUS.TERMINATED: {
      return BADGE_STATUSES.TERMINATED;
    }
    default: {
      return BADGE_STATUSES.UNKNOWN;
    }
  }
};

export type SubscriptionStatusBadgeProps = {
  subscriptionStatus: SubscriptionStatus;
};

export const SubscriptionStatusBadge = ({ subscriptionStatus }: SubscriptionStatusBadgeProps) => {
  const { t } = useTranslation();
  return (
    <StatusBadge
      type="text"
      status={getBadgeStatusBaseOnSubscriptionStatus(subscriptionStatus)}
      label={getLabelBaseOnSubscriptionStatus(subscriptionStatus, t)}
    />
  );
};
